import merge from 'deepmerge';
import configCommon from  './config_common';
import configLocal from  './config_local';
import configStable from './config_stable';
import configProd from './config_prod';

let config = merge(configCommon, configLocal);
if (process.env.REACT_APP_ENV === 'stable') {
    config = merge(configCommon, configStable);
} else if (process.env.REACT_APP_ENV === 'prod') {
    config = merge(configCommon, configProd);
}

export default config;


// WEBPACK FOOTER //
// ./src/configuration/index.js